import React from 'react';

const ArrowDownSecondary = ({ backgroundColor, height, width, className }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        viewBox="0 0 8.957 5.287"
        width={width}
        className={className}
    >
        <g transform="translate(2.031 3.005)" fill={backgroundColor}>
            <path
                className="a"
                d="M1.354.229l3.1,3.108L7.559.229A.8.8,0,0,1,8.692,1.362L5,5.049a.806.806,0,0,1-1.132,0L.185,1.362A.806.806,0,0,1,.217.229a.822.822,0,0,1,1.138,0Z"
                transform="translate(-2 -3)"
            />
        </g>
    </svg>
);

export default ArrowDownSecondary;
